import { User, Wallet, Card, Transaction, Portfolio, RewardStats, Reward } from '@/types'

export const mockUser: User = {
  id: 'user-001',
  email: 'alex@acmeai.io',
  firstName: 'Alex',
  lastName: 'Chen',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Alex',
  kycStatus: 'approved',
  createdAt: '2024-01-10T00:00:00Z',
}

export const mockWallets: Wallet[] = [
  {
    id: 'wallet-001',
    address: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb',
    network: 'base',
    balance: {
      usdc: 125430.50,
      usdt: 25000.00,
      eth: 12.45,
      totalUsd: 150430.50,
    },
    isDefault: true,
  },
  {
    id: 'wallet-002',
    address: '0x8ba1f0c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8',
    network: 'ethereum',
    balance: {
      usdc: 50000.00,
      usdt: 0,
      eth: 5.20,
      totalUsd: 61240.00,
    },
    isDefault: false,
  },
]

export const mockCards: Card[] = [
  {
    id: 'card-001',
    lastFour: '4242',
    expiryMonth: '12',
    expiryYear: '27',
    cardholderName: 'Alex Chen',
    status: 'active',
    type: 'virtual',
    tier: 'premium',
    spendingLimit: 50000,
    dailySpent: 2340.50,
    monthlySpent: 18560.75,
    color: 'purple',
    isDefault: true,
  },
  {
    id: 'card-002',
    lastFour: '8888',
    expiryMonth: '09',
    expiryYear: '26',
    cardholderName: 'Alex Chen',
    status: 'active',
    type: 'virtual',
    tier: 'standard',
    spendingLimit: 10000,
    dailySpent: 150.00,
    monthlySpent: 2340.00,
    color: 'cyan',
    isDefault: false,
  },
  {
    id: 'card-003',
    lastFour: '0002',
    expiryMonth: '06',
    expiryYear: '28',
    cardholderName: 'Alex Chen',
    status: 'frozen',
    type: 'physical',
    tier: 'limited',
    spendingLimit: 100000,
    dailySpent: 0,
    monthlySpent: 0,
    color: 'orange',
    isDefault: false,
  },
]

export const mockTransactions: Transaction[] = [
  {
    id: 'tx-001',
    type: 'card_payment',
    amount: -299.99,
    currency: 'USD',
    usdValue: 299.99,
    status: 'completed',
    merchantName: 'AWS Services',
    merchantIcon: '☁️',
    cardLastFour: '4242',
    timestamp: '2024-01-15T14:30:00Z',
  },
  {
    id: 'tx-002',
    type: 'deposit',
    amount: 50000,
    currency: 'USDC',
    usdValue: 50000,
    status: 'completed',
    description: 'Deposit from Coinbase',
    timestamp: '2024-01-15T10:00:00Z',
    txHash: '0xabc...def',
  },
  {
    id: 'tx-003',
    type: 'card_payment',
    amount: -89.50,
    currency: 'USD',
    usdValue: 89.50,
    status: 'completed',
    merchantName: 'Notion',
    merchantIcon: '📝',
    cardLastFour: '4242',
    timestamp: '2024-01-14T16:45:00Z',
  },
  {
    id: 'tx-004',
    type: 'card_payment',
    amount: -29.00,
    currency: 'USD',
    usdValue: 29.00,
    status: 'completed',
    merchantName: 'Figma',
    merchantIcon: '🎨',
    cardLastFour: '4242',
    timestamp: '2024-01-14T09:20:00Z',
  },
  {
    id: 'tx-005',
    type: 'reward',
    amount: 125.50,
    currency: 'USD',
    usdValue: 125.50,
    status: 'completed',
    description: 'Cashback reward',
    timestamp: '2024-01-13T00:00:00Z',
  },
  {
    id: 'tx-006',
    type: 'transfer_out',
    amount: -5000,
    currency: 'USDC',
    usdValue: 5000,
    status: 'completed',
    description: 'Transfer to team wallet',
    timestamp: '2024-01-12T11:30:00Z',
    txHash: '0x123...456',
  },
  {
    id: 'tx-007',
    type: 'card_payment',
    amount: -199.00,
    currency: 'USD',
    usdValue: 199.00,
    status: 'completed',
    merchantName: 'GitHub',
    merchantIcon: '💻',
    cardLastFour: '8888',
    timestamp: '2024-01-11T08:15:00Z',
  },
  {
    id: 'tx-008',
    type: 'deposit',
    amount: 25000,
    currency: 'USDC',
    usdValue: 25000,
    status: 'completed',
    description: 'Investor funding',
    timestamp: '2024-01-10T15:00:00Z',
    txHash: '0x789...012',
  },
]

export const mockPortfolio: Portfolio = {
  totalValue: 211670.50,
  change24h: 3240.50,
  change24hPercent: 1.55,
  assets: [
    {
      symbol: 'USDC',
      name: 'USD Coin',
      balance: 175430.50,
      price: 1.00,
      value: 175430.50,
      allocation: 82.8,
      change24h: 0,
    },
    {
      symbol: 'USDT',
      name: 'Tether',
      balance: 25000.00,
      price: 1.00,
      value: 25000.00,
      allocation: 11.8,
      change24h: 0.01,
    },
    {
      symbol: 'ETH',
      name: 'Ethereum',
      balance: 17.65,
      price: 634.50,
      value: 11240.00,
      allocation: 5.3,
      change24h: 2.35,
    },
  ],
}

export const mockSpendingCategories = [
  { name: 'Software', amount: 4580.50, percentage: 35, color: '#8B5CF6' },
  { name: 'Cloud', amount: 3240.00, percentage: 25, color: '#3B82F6' },
  { name: 'Travel', amount: 2100.00, percentage: 16, color: '#06B6D4' },
  { name: 'Office', amount: 1560.00, percentage: 12, color: '#10B981' },
  { name: 'Other', amount: 1560.50, percentage: 12, color: '#71717A' },
]

export const mockRewardStats: RewardStats = {
  totalPoints: 12580,
  pointsValue: 754.80,
  cashbackRate: 5,
  monthlyEarnings: 340.50,
  lifetimeEarnings: 2450.75,
}

export const mockRewards: Reward[] = [
  {
    id: 'reward-001',
    type: 'cashback',
    amount: 125.50,
    points: 2092,
    description: 'January cashback',
    timestamp: '2024-01-13T00:00:00Z',
  },
  {
    id: 'reward-002',
    type: 'referral',
    amount: 100.00,
    points: 1667,
    description: 'Referral bonus - Sarah M.',
    timestamp: '2024-01-10T00:00:00Z',
  },
  {
    id: 'reward-003',
    type: 'staking',
    amount: 45.20,
    points: 753,
    description: 'SOL staking rewards',
    timestamp: '2024-01-08T00:00:00Z',
  },
]

export const mockQuote = {
  fromAmount: 1000,
  fromCurrency: 'USDC',
  toAmount: 985.50,
  toCurrency: 'USD',
  exchangeRate: 1.00,
  fee: 14.50,
  feePercent: 1.5,
  netAmount: 985.50,
  expiresAt: new Date(Date.now() + 30000).toISOString(),
}